<template>
    <div>
        <aside class="filters">
            <h1>{{ titleTranslation }}</h1>

            <alf-catalog-type-switcher
                    :filter-types="filterTypes">

            </alf-catalog-type-switcher>

            <!--<div class="mobile-filter__open filter__btn">-->
                <!--<a  href="#/" @click="filterVisible = !filterVisible">{{ filterText }}</a>-->
            <!--</div>&lt;!&ndash; /.filter__btn &ndash;&gt;-->
            <div class="mobile-filter__open filter__btn">

                <button @click="toggleScroll">
                    <span v-text="filterText">
                      </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14.3" ><path d="M14 7.2L6.9 0l-.6.6 6 6.1H0v.9h12.3l-6 6.1.6.6z"/></svg>
                    <!--<span class="icon"></span>-->
                </button>

            </div><!-- /.filter__btn -->

            <div class="filter-section" :class="{visible: filterVisible}">

                <alf-edition-switcher
                    :editions="editions"
                    :active-filter="activeFilter"
                    :active-edition-id="activeEdition.id">
                </alf-edition-switcher>

                <alf-catalog-select-filter
                    :artworks="artworks"
                    :artists="artists"
                    :active-filter="activeFilter.type"
                    ref="filterComponent">
                </alf-catalog-select-filter>

                <p class="filter--pgh" v-if="activeEdition">{{ helpers.getTranslation(activeEdition, 'description') }}</p>

                <button @click="toggleScroll" class="mobile-filter__close filter-btn">{{ applyFilterText }}</button>

                <!-- ugly fix, to make the button visible -->
                <!--<div style="width: 100%; height: 70px;"></div>-->

            </div><!-- /.filter-section -->
        </aside><!-- /.aside -->


        <alf-catalog-listing ref="listing" :catalog-items="filteredCatalogItems" :loadingState="loadingState" :activeEdition="activeEdition"></alf-catalog-listing>

    </div>
</template>

<script>

/*
 * Import child components
 */
import CatalogListing from './catalog-listing'
import CatalogTypeSwitcher from './catalog-type-switcher'
import EditionSwitcher from './edition-switcher'
import CatalogSelectFilter from './catalog-select-filter'
import axios from 'axios'
import artworkFilter from './filterable'
import helpers from './../../helpers'
import FilterTypes from './filter-types'

axios.defaults.headers['Content-Type'] = 'application/json';
axios.defaults.headers['Accept'] = 'application/json';

export default {
    components: {
        'alf-catalog-listing': CatalogListing,
        'alf-edition-switcher': EditionSwitcher,
        'alf-catalog-select-filter': CatalogSelectFilter,
        'alf-catalog-type-switcher': CatalogTypeSwitcher,
    },
    props: {
        'activeEditionData': { required: true },
        'artworksData': { required: true },
        'artistsData': { required: true },
        'editions': { required: true }
    },

    data: function() {
        return {
            helpers: helpers,
            filterTypes: FilterTypes,
            loadingState: true,
            filterVisible: false,
            mounted: false,
            activeFilter: null,
            activeEdition: null,
            artworks: null,
            catalogItems: null,
            artists: null,
            newsletterButton: null,
            filters: {
                artworkModel: null,
                artistModel: null
            }
        }
    },

    beforeMount: function() {
        this.activeEdition = this.activeEditionData;
        this.artworks = this.artworksData;
        this.artists = this.artistsData;


        this.catalogItems = this[this.getRightFilterType(this.$route.params.catalog)];
        this.setActiveFilter(this.$route.params.catalog);
    },

    mounted: function() {
        this.mounted = true;
        this.loadingState = false;
        this.newsletterButton = document.getElementsByClassName('newsletter-action')[0];
    },

    computed: {
        filteredCatalogItems: function() {
            if(!this.mounted || !this.hasFilter) return this.catalogItems

            return this.catalogItems.filter(this.filterCatalogItems);
        },
        hasFilter: function() {
            return (
                this.$refs.filterComponent.filters.artworkModel !== null ||
                this.$refs.filterComponent.filters.artistModel !== null
            )
        },
        titleTranslation: function(){
            if(helpers.getLocale() === 'nl') {
                return 'KUNST'
            }
            return 'ART'
        },
        filterText(){
            if(helpers.getLocale() === 'nl') {
                return 'FILTEREN';
            }
            return 'FILTER';
        },
        applyFilterText(){
            if(helpers.getLocale() === 'nl') {
                return 'FILTER TOEPASSEN';
            }
            return 'APPLY FILTER';
        }
    },

    watch: {
        '$route.params.slug': function() {
            const slug = this.$route.params.slug;
            console.dir(slug);
            if(slug) {
                this.fetchNewCatalogItems(slug)
            }
        },
        '$route.params.catalog': function(catalogType) {
            this.fetchNewCatalogItems('edition-9');
            this.setActiveFilter(catalogType);
        },
        'filterVisible': function(visible){
            (visible) ? this.newsletterButton.style.display = 'none' : this.newsletterButton.style.display = 'block';
        }
    },

    methods: {
        toggleScroll: function(){
            this.filterVisible = !this.filterVisible
            if(this.filterVisible) {
                document.body.classList.add('overflow-hidden')
            }else{
                document.body.classList.remove('overflow-hidden')
            }
        },
        getRightFilterType: function(type){
            if(type === 'kunstwerken' || type === 'artworks') {
                return 'artworks';
            }

            return 'artists'
        },
        setActiveFilter: function(catalogType){

            catalogType = this.getRightFilterType(catalogType);

            this.activeFilter = this.filterTypes[catalogType];
        },
        fetchNewCatalogItems: function(slug) {
            let self = this;
            self.loadingState = true;
            axios.get('/api/v1/' + this.activeFilter.fetchUrl + '/' + slug + '?locale=' + helpers.getLocale())
                .then(function (response) {

                    // Reset the filters
                    self.$refs.filterComponent.resetFilter();

                    // Set new listing state
                    self.activeEdition = response.data.activeEdition;
                    self.artists = response.data.artists;
                    self.artworks = response.data.artworks;
                    self.catalogItems = response.data[self.activeFilter.collection];

                    self.loadingState = false
                })
                .catch(function (error) {
                    console.error(error);
                    self.loadingState = false
                })
        },
        filterCatalogItems: function(catalogItem) {
            const filterValue = this.$refs.filterComponent.filters[this.activeFilter.model];

            if (filterValue !== null) {
                catalogItem = artworkFilter['catalogItemModel'](catalogItem, filterValue)
            }

            return catalogItem
        }
    }
}
</script>

<style lang="scss" scoped>
    .filter__btn{
        border: none;
        max-width: 288px;
        margin-left: 0;
        padding:0px;
        button{
            padding: 0 13px;
            border: 1px solid #000000;
            border-radius: 55px;
            background: none;
            font-size: 14px;
            svg{
                margin-bottom: 2px;
                transition: transform 0.1s linear;
            }
            &:hover svg {
                transform: translateX(5px);
            }
        }
    }

    .filter-btn{
        width: 100%;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/catalog-filter/catalog-filter-root.vue